import {put, takeEvery} from "redux-saga/effects";
import {Category} from "../../../Models/Category";
import {
    categoriesGetError,
    categoriesGetSuccess,
    categoryCreateError,
    categoryCreateSuccess,
    categoryLoadError,
    categoryLoadSuccess,
    categoryUpdateError,
    categoryUpdateSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* categoriesSagas() {
    yield takeEvery(TYPES.CATEGORIES_GET_REQUEST, categoriesGetRequest);
    yield takeEvery(TYPES.CATEGORY_LOAD_REQUEST, categoryLoadRequest);
    yield takeEvery(TYPES.CATEGORY_CREATE_REQUEST, categoryCreateRequest);
    yield takeEvery(TYPES.CATEGORY_UPDATE_REQUEST, categoryUpdateRequest);
}

function* categoriesGetRequest(action) {
    try {
        const response = yield Category.index({
            ...action.payload,
        });

        yield put(
            categoriesGetSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(categoriesGetError(error));
    }
}

function* categoryLoadRequest(action) {
    try {
        const response = yield Category.find(action.payload);

        yield put(
            categoryLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(categoryLoadError(error));
    }
}

function* categoryCreateRequest(action) {
    try {
        const response = yield Category.create(action.payload);

        yield put(
            categoryCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(categoryCreateError(error));
    }
}

function* categoryUpdateRequest(action) {
    try {
        const response = yield Category.update(action.payload.id, action.payload);

        yield put(
            categoryUpdateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(categoryUpdateError(error));
    }
}
